import { addPageAction } from '@nike/ux-tread-new-relic';

/**
 * @ignore
 * wrapped addPageAction with version
 * @param {string} actionName - name of the new relic page action to send
 * @param {string} version - instantiated version of this module
 * @returns {undefined} async call with no return value
 */
// maybe swap page action title
export default function onErrorCallback(actionName, version) {
  return addPageAction(actionName, {
    version,
  });
}
